import { IRestModel } from "@nkr/utils/rest-api";
import { OrganType } from "@nkr/enums/organ-type";
import { DashLabsStatus } from "./dash-enums";

export interface IDashListSummary extends IRestModel {
    id                                      : number,
    source                                  : string,
    organType                               : OrganType,
    firstName                               : string,
    lastName                                : string,
    dob                                     : string | null,
    abo                                     : string | null,
    location                                : string | null,
    registrationCenterId                    : number | null,
    registrationCenterAlias                 : string | null,
    registrationStep                        : number | null,
    registrationStatus                      : string,
    centerWorkflowId                        : number | null,
    centerWorkflowDescription               : string | null,
    centerWorkflowNextFollowUpDate          : string | null,

    isRemoteDonor                           : boolean | null,
    isReadOnly                             : boolean,
    networkStatusId                         : number | null,
    networkStatusDescription                : string | null,
    networkStatusDate                       : string | null,
    networkStatusLastUpdatedDate            : string | null,
    networkStatusComments                   : string | null,

    preWorkupLabStatus                      : DashLabsStatus | null,
    preWorkupLabResultsDate                 : string | null,

    registrationDate                         : string,
    intakeCompleteDate                       : string | null,
    donationDate                             : string | null,

    donationType                             : string | null,
    donationEpletMm                          : string | null,
    isInExpertSystem                         : boolean | null,

    intendedDonationType                     : string, //SV/FV/DD/NDD
    intendedRecipientIsLocal                 : boolean | null,
    intendedRecipientCenterId                : number | null,
    intendedRecipientCenterAlias             : string | null,
    intendedRecipientCenterIsParticipating   : boolean | null,
    intendedRecipientFirstName               : string | null,
    intendedRecipientLastName                : string | null,
    intendedRecipientDob                     : string | null,
    intendedRecipientRelationship            : string | null,

    coordinatorId                            : number | null,
    coordinatorName                          : string | null,
    coordinatorEmail                         : string | null,

    recipientCoordinatorId                   : number | null,
    recipientCoordinatorName                 : string | null,
    recipientCoordinatorEmail                : string | null,
};